import { assert } from '../../lib/assert-sidecar'
import { stringUtils } from '../../lib/stringUtils-sidecar'
import { common } from '../../main/common-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageCrew_crew } from './voyageCrew_crew-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  // voyageGameStatus.get().hasReactorRunning.willBeActive = true

  let useSystemTime = 3
  d.useSystemTimer += ds
  voyageCrew_crew.setProgress(obj, d.useSystemTimer / useSystemTime)

  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    if (voyageSystems.testNoPower(obj)) {
      return
    }

    let status = voyageGameStatus.get()

    voyageCrew.say(
      obj,
      'Jump drive charged to ' +
        stringUtils.formatInteger(status.jumpCharge) +
        '%',
    )

    status.addJumpCharge += 15.0 // TODO: based on ship?
  }
}
